class Constants {
  static MODE_VIEW = "View";
  static MODE_EDITION = "Edition";
  static MODE_LOADING = "Loading";
  static MODE_LOADED = "Loaded";
  static MODE_SAVING = "Saving";
  static MODE_DELETING = "Deleting";
  static MODE_SORTING = "Sorting";
  static MODE_COLLAPSED = "Collapsed";
  static MODE_EXPANDED = "Expanded";
  static MODE_SAVED = "Saved";
  static MODE_ORDER_PLACE = "Order";
  static ROUTE_BASE_API = process.env.REACT_APP_APIURL;

  static CONTINENTS = [
    { IDLOCATION: 3, DESCRIPTION: "USA", SIMPLEDESCRIPTION: "USA", IDPARENT: 0 },
    { IDLOCATION: 4, DESCRIPTION: "Canada", SIMPLEDESCRIPTION: "Canada", IDPARENT: 0 },
    { IDLOCATION: 1, DESCRIPTION: "Europe", SIMPLEDESCRIPTION: "Europe", IDPARENT: 0 },
    { IDLOCATION: 7, DESCRIPTION: "Asia & Middle East", SIMPLEDESCRIPTION: "Asia & Middle East", IDPARENT: 0 },
    { IDLOCATION: 8, DESCRIPTION: "Australasia", SIMPLEDESCRIPTION: "Australasia", IDPARENT: 0 },
    { IDLOCATION: 9, DESCRIPTION: "Latin America", SIMPLEDESCRIPTION: "Latin America", IDPARENT: 0 },
    { IDLOCATION: 10, DESCRIPTION: "Africa", SIMPLEDESCRIPTION: "Africa", IDPARENT: 0 },
  ];

  static DISCARDREASON = {
    CompetitorSite: 1,
    Distributor: 2,
    OutOfScope: 3,
    Duplicate: 4,
    ExcludeDomain: 5,
  };

  static monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  static PAGE_SIZE = 15;
  static MAX_AJAX_CALLING_RETRIES = 3;

  static RESEARCH_TASKS_STATUS = {
    Queued: 1,
    Processed: 2,
    ProcessedWithErrors: 3,
    Deleted: 4,
  };

  static PRODUCTTYPE = [
    { idProductType: "0", name: "Company" },
    { idProductType: "2", name: "Equipment" },
    { idProductType: "1", name: "Service" },
    { idProductType: "4", name: "Software" },
    { idProductType: "11", name: "Training" },
    { idProductType: "12", name: "Application" },
    { idProductType: "6", name: "Article" },
    { idProductType: "5", name: "Book" },
    { idProductType: "19", name: "Download" },
    { idProductType: "3", name: "Event" },
    { idProductType: "9", name: "Magazine" },
    { idProductType: "8", name: "News" },
    { idProductType: "20", name: "Video" },
  ];

  //ROUTES

  static ROUTE_USER_LOGIN = this.ROUTE_BASE_API + "/api/User/Login";

  //ROUTES ACTIVITY LOG
  static ROUTE_API_CONTENTORGANIZATION = this.ROUTE_BASE_API + "/api/contentorganization";
  static ROUTE_API_CONTENTORGANIZATION_DETAILS = this.ROUTE_BASE_API + "/api/contentorganization/details";
  static ROUTE_API_CONTENTORGANIZATION_TYPES = this.ROUTE_BASE_API + "/api/contentorganization/types";
  static ROUTE_API_CONTENTORGANIZATION_STAFF = this.ROUTE_BASE_API + "/api/ContentOrganization/Staff";
  static ROUTE_API_DASHBOARD_CATEGORIES_DISTRIBUTION = this.ROUTE_BASE_API + "/api/Dashboard/CategoriesDistribution";
  static ROUTE_API_DASHBOARD_KEYWORDS_DISTRIBUTION = this.ROUTE_BASE_API + "/api/Dashboard/KeywordsDistribution";
  static ROUTE_API_DASHBOARD_STAFF_CONTRIBUTION = this.ROUTE_BASE_API + "/api/Dashboard/StaffContribution";
  static ROUTE_API_DASHBOARD_TOTAL_KEYWORD_SYNONYM = this.ROUTE_BASE_API + "/api/Dashboard/KeywordsAndSynonymsLog";
  static ROUTE_API_DASHBOARD_UNRELATED_KEYWORDS = this.ROUTE_BASE_API + "/api/Dashboard/UnrelatedKeywords";
  static ROUTE_API_DASHBOARD_TITLE_WITH_NO_KEYWORDS = this.ROUTE_BASE_API + "/api/Dashboard/TitlesWithNoKeywordsLog";
  static ROUTE_API_CONTENTORGANIZATION_CHART_KEYWORDS_ADDED_VS_DELETED = this.ROUTE_BASE_API + "/api/ContentOrganization/ChartKeywordsAddedDeleted";
  static ROUTE_API_CONTENTORGANIZATION_CHART_KEYWORDS_MODIFIED = this.ROUTE_BASE_API + "/api/ContentOrganization/ChartKeywordsModified";
  static ROUTE_API_CONTENTORGANIZATION_CHART_RELATIONSHIPS_ADDED_VS_DELETED = this.ROUTE_BASE_API + "/api/ContentOrganization/ChartRelationshipsAddedDeleted";

  //RESEARCH TASKS
  static ROUTE_API_CATEGORIES_AUTOCOMPLETE = this.ROUTE_BASE_API + "/api/Categories/Autocomplete";
  static ROUTE_API_ATTRIBUTES_AUTOCOMPLETE = this.ROUTE_BASE_API + "/api/Attributes/Autocomplete";
  static ROUTE_API_CATEGORIES_KEYWORDS_BY_CATEGORY = this.ROUTE_BASE_API + "/api/Categories/GetKeywordsByCategory";
  static ROUTE_API_RESEARCH_TASK = this.ROUTE_BASE_API + "/api/ResearchTask";
  static ROUTE_API_RESEARCH_TASK_DELETE_ALL = this.ROUTE_BASE_API + "/api/ResearchTask/deleteAll";
  static ROUTE_API_RESEARCH_TASK_RESULTS = this.ROUTE_BASE_API + "/api/researchtask/results";
  static ROUTE_API_RESEARCH_TASK_RESULTS_KEYWORDS = this.ROUTE_BASE_API + "/api/researchtask/results/keywords";
  static ROUTE_API_RESEARCH_TASK_RESULTS_DISCARD_REASONS = this.ROUTE_BASE_API + "/api/ResearchTask/discardreasons";
  static ROUTE_API_RESEARCH_TASK_RESULTS_DISCARD = this.ROUTE_BASE_API + "/api/ResearchTask/putresearchresultdiscard";
  static ROUTE_API_RESEARCH_TASK_RESULTS_PID = this.ROUTE_BASE_API + "/api/ResearchTask/resultspid";
  static ROUTE_API_RESEARCH_TASK_CHECKISPOSIBLELOADIFRAME = this.ROUTE_BASE_API + "/api/ResearchTask/CheckIsPosibleLoadIframe";

  //RESEARCH TYPES
  static RESEARCHTYPES = {
    Organic: 1,
    Paid: 2
  }

  //ROUTES CONTENT
  static ROUTE_API_CONTENT_WEBPRODUCTS = this.ROUTE_BASE_API + "/api/WebProducts";
  static ROUTE_API_COMMONDATA = this.ROUTE_BASE_API + "/api/CommonData";
  static ROUTE_API_CATEGORIES = this.ROUTE_BASE_API + "/api/Categories";
  static ROUTE_API_CATEGORIES_SUPER_CATEGORIES = this.ROUTE_BASE_API + "/api/Categories/GetSuperCategoriesGetList";
  static ROUTE_API_CATEGORIES_CREATE_CATEGORY = this.ROUTE_BASE_API + "/api/Categories/CreateNewCategory";
  static ROUTE_API_CATEGORIES_INSERT_KEYWORD_CATEGORY = this.ROUTE_BASE_API + "/api/Categories/InsertKeywordCategory";
  static ROUTE_API_CATEGORIES_DELETE_KEYWORD_CATEGORY = this.ROUTE_BASE_API + "/api/Categories/DeleteKeywordCategory";
  static ROUTE_API_CONTENT_ATTRIBUTES_BY_KEYWORD = this.ROUTE_BASE_API + "/api/Attributes/AttributesByKeyword";
  static ROUTE_API_ATTRIBUTES_INSERT_KEYWORD_ATTRIBUTE = this.ROUTE_BASE_API + "/api/Attributes/InsertKeywordAttribute";
  static ROUTE_API_ATTRIBUTES_DELETE_KEYWORD_ATTRIBUTE = this.ROUTE_BASE_API + "/api/Attributes/DeleteKeywordAttribute";
  static ROUTE_API_CONTENT_SYNONYMS_BY_KEYWORD = this.ROUTE_BASE_API + "/api/Synonyms/SynonymsByKeyword";

  static ROUTE_API_KEYWORDS = this.ROUTE_BASE_API + "/api/Keywords";
  static ROUTE_API_CONTENT_WEBPRODUCTS_GET_SUGGESTER = this.ROUTE_BASE_API + "/api/WebProducts/GetTitleSuggestions";


  //ROUTES KEYWORDMANAGEMENT
  static ROUTE_API_CONTENT_SEARCH_BY_KEYWORD = this.ROUTE_BASE_API + "/api/keywords";
  static ROUTE_API_CONTENT_DETAILS_BY_KEYWORD = this.ROUTE_BASE_API + "/api/keywords/details";
  static ROUTE_API_CONTENT_KEYWORDS_CATEGORIES_LIST = this.ROUTE_BASE_API + "/api/keywords/keywordscategorieslist";
  static ROUTE_API_CONTENT_KEYWORDS_CATEGORIES_LIST_RESEARCH = this.ROUTE_BASE_API + "/api/keywords/keywordscategorieslistresearch";
  static ROUTE_API_CONTENT_RELATED_CONTENT_BY_KEYWORD = this.ROUTE_BASE_API + "/api/Keywords/relatedcontent";
  static ROUTE_API_CONTENT_GET_COUNTERS_BY_SITE_KEYWORD = this.ROUTE_BASE_API + "/api/Keywords/getcountersbysite";
  static ROUTE_API_CONTENT_KEYWORDS_MULTIPLE = this.ROUTE_BASE_API + "/api/keywords/keywordsmultiple";
  static ROUTE_API_CONTENT_KEYWORDS_ANALYZER = this.ROUTE_BASE_API + "/api/keywords/keywordanalyzer";
  static ROUTE_API_CONTENT_KEYWORDS_IS_VALID_TO_ADD = this.ROUTE_BASE_API + "/api/keywords/isvalidtoadd";
  static ROUTE_API_CONTENT_COMPANY_BY_KEYWORDS = this.ROUTE_BASE_API + "/api/keywords/getcountercompanybykeyword";
  static ROUTE_API_CONTENT_KEYWORDS_IS_VALID_TO_ADD_MULTIPLE = this.ROUTE_BASE_API + "/api/keywords/isvalidtoaddmultiple";

  //ROUTES RESEARCH RESULT NOT ALLOWED DOMAINS
  static ROUTE_API_RESEARCH_RESULT_NOT_ALLOWED_DOMAIN = this.ROUTE_BASE_API + "/api/ManageDomains";

  //ROUTES VALIDATION
  static ROUTE_API_VALIDATION_ISKEYWORD_REPEATED = this.ROUTE_BASE_API + "/api/Validation/IsKeywordRepeated";
  static ROUTE_API_VALIDATION_ISCATEGORY_EXISTS = this.ROUTE_BASE_API + "/api/Validation/IsCategoryExist";

  // KEYWORDMANAGEMENT MENU
  static MENU_BULK_ACTION_OPTIONS = [
    { key: 1, name: "Relate" },
    { key: 2, name: "Unrelate" },
    { key: 5, name: "Delete" },
    { key: 6, name: "Research" },
  ];

  static MAX_KEYWORD_LENGTH = 100;

  static ALERT_ERROR = "error";
  static ALERT_WARNING = "warning";
  static ALERT_INFO = "info";
  static ALERT_SUCCESS = "success";

  static ProcessAgain = -99;

  static SUPPLIER_JOB_STATUS_ENUM = {
    Processing: null,
    New: 0,
    Approved: 1,
    Discarded: 2,
    Success: 3,
    Error: 4,
  };

  static SUPPLIER_JOB_STATUS = [
    { id: null, value: "Processing", showDropdown: true, background: "primary", icon: "cached" },
    { id: 0, value: "New", showDropdown: true, background: "primary", icon: "add" },
    { id: 1, value: "Approved", showDropdown: true, background: "primary", icon: "fact-check-outlined" },
    { id: 2, value: "Discarded", showDropdown: true, background: "primary", icon: "clear" },
    { id: 3, value: "Success", showDropdown: false, background: "primary", icon: "done" },
    { id: 4, value: "Error", showDropdown: true, background: "warning", icon: "announcement" },
  ];

  static SUPPLIER_JOB_TYPE = [
    { id: 1, value: "Crawl" },
    { id: 2, value: "Keywords" },
    { id: 3, value: "Entity" },
    { id: 4, value: "Category" },
    { id: 5, value: "Eligibility" },
    { id: 6, value: "Score" },
  ];

  static SUPPLIER_JOB_ISSUPPLIER_ENUM = {
    Yes: 1,
    No: 0,
  };

  static SUPPLIER_JOB_ISSUPPLIER = [
    { id: 1, text: "Yes", value: true },
    { id: 0, text: "No", value: false },
  ];

  static RESEARCH_LIST_TYPE = [
    { id: 1, text: "KW"},
    { id: 2, text: "SYN"},
  ];
}

export default Constants;
